import get from 'object-get';
import i18next from 'i18next';
import fallbackTranslations from '../assets/locales/translation.zu.json';

export const t = (key, data) =>
  // FIXME: fallback translations doesn't work with var substitution
  i18next.t(`app-shell:${key}`, data) || get(fallbackTranslations, key);
